import React, { Component } from "react";
import axios from 'axios';
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

// A retailer session is the normal case. Admin-panel users (super admin and
// operations) drive the same pharmacy stock endpoints from the Stock Upload
// screen, where the pharmacy comes from a dropdown rather than the session, so
// on those paths the admin token is the session that counts - a pharmacy token
// left behind in this browser by an earlier login must not win.
export function retailerAuthToken() {
  const adminToken = localStorage.getItem('AdminToken') || "";
  const onAdminPanel =
    typeof window !== "undefined" &&
    /^\/(admin|operations)(\/|$)/i.test(window.location.pathname);
  if (onAdminPanel && adminToken) return adminToken;

  const retailerToken = ls.get('retailerToken');
  if (retailerToken) return retailerToken;
  return adminToken;
}

const authHeaders = () => ({ 'Authorization': retailerAuthToken() });

export default {

  httpPost(url,postdata){
    return axios.post(url, postdata)
  },
  httptokenpost(url,postdata){
    const options = {   headers: authHeaders() }
    return axios.post(url, postdata,options);
  },
  // Special POST with extended timeout for large data operations
  httptokenpostWithTimeout(url, postdata, timeoutMs = 300000) { // 5 minutes default
    const options = {
      headers: authHeaders(),
      timeout: timeoutMs // Custom timeout in milliseconds
    }
    return axios.post(url, postdata, options);
  },
  // POST expecting a binary (blob) response, useful for file downloads
  httptokenpostDownload(url, postdata){
    const options = {
      headers: authHeaders(),
      responseType: 'blob'
    }
    return axios.post(url, postdata, options);
  },
  httptokenget(url){

    const options = {   headers: authHeaders() }
    return axios.get(url,options);
  },
  httptokendelete(url){
    const options = {   headers: authHeaders() }
    return axios.delete(url,options);
  },
  httptokenput(url,putdata){
    const options = {   headers: authHeaders() }
    return axios.put(url,putdata,options);
  }

}
